module.exports = __webpack_public_path__ + "img/page-active-title.c79c8094.png";